let store = null;
/** Called once at app bootstrap to wire the environment's storage handler. */
export function registerSiteContentStore(handler) {
    store = handler;
}
export function getSiteContentStore() {
    if (!store) {
        throw new Error('site-content: no store registered — call registerSiteContentStore() at bootstrap');
    }
    return store;
}
//# sourceMappingURL=store.js.map